/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DancesRouteRouteImport } from './routes/dances/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as UiShowcaseRouteImport } from './routes/ui-showcase'
import { Route as UsersRouteImport } from './routes/users'
import { Route as BallroomsIndexRouteImport } from './routes/ballrooms/index'
import { Route as DancesIndexRouteImport } from './routes/dances/index'
import { Route as DancesDanceIdRouteImport } from './routes/dances/$danceId'
import { Route as EventsNewRouteImport } from './routes/events/new'
import { Route as VolunteersIndexRouteImport } from './routes/volunteers/index'
import { Route as EventsEventIdChar123EventVersionIdChar125RouteRouteImport } from './routes/events/$eventId.{-$eventVersionId}/route'
import { Route as DancesDanceIdVersionDanceVersionIdRouteImport } from './routes/dances/$danceId.version.$danceVersionId'
import { Route as EventsEventIdVersionEventVersionIdRouteImport } from './routes/events/$eventId.version.$eventVersionId'
import { Route as EventsEventIdChar123EventVersionIdChar125IndexRouteImport } from './routes/events/$eventId.{-$eventVersionId}/index'
import { Route as EventsEventIdChar123EventVersionIdChar125EditRouteImport } from './routes/events/$eventId.{-$eventVersionId}/edit'
import { Route as EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteImport } from './routes/events/$eventId.{-$eventVersionId}/program/route'
import { Route as EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRouteImport } from './routes/events/$eventId.{-$eventVersionId}/assignments/index'
import { Route as EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125RouteImport } from './routes/events/$eventId.{-$eventVersionId}/ball-program/{-$slideId}'
import { Route as EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteImport } from './routes/events/$eventId.{-$eventVersionId}/documents/$documentId/route'
import { Route as EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRouteImport } from './routes/events/$eventId.{-$eventVersionId}/print/ball-dancelist'
import { Route as EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRouteImport } from './routes/events/$eventId.{-$eventVersionId}/print/dance-cheatlist'
import { Route as EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRouteImport } from './routes/events/$eventId.{-$eventVersionId}/print/dance-instructions'
import { Route as EventsEventIdChar123EventVersionIdChar125VolunteersIndexRouteImport } from './routes/events/$eventId.{-$eventVersionId}/volunteers/index'
import { Route as EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteImport } from './routes/events/$eventId.{-$eventVersionId}/workshops.$workshopId/route'
import { Route as EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRouteImport } from './routes/events/$eventId.{-$eventVersionId}/documents/$documentId/index'
import { Route as EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRouteImport } from './routes/events/$eventId.{-$eventVersionId}/documents/$documentId/edit'
import { Route as EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRouteImport } from './routes/events/$eventId.{-$eventVersionId}/program/main/index'
import { Route as EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125RouteImport } from './routes/events/$eventId.{-$eventVersionId}/program/slides/{-$slideId}'
import { Route as EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRouteImport } from './routes/events/$eventId.{-$eventVersionId}/workshops.$workshopId/index'
import { Route as EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteImport } from './routes/events/$eventId.{-$eventVersionId}/workshops.$workshopId/documents/$documentId/route'
import { Route as EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRouteImport } from './routes/events/$eventId.{-$eventVersionId}/workshops.$workshopId/documents/$documentId/index'
import { Route as EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRouteImport } from './routes/events/$eventId.{-$eventVersionId}/workshops.$workshopId/documents/$documentId/edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DancesRouteRoute = DancesRouteRouteImport.update({
  id: '/dances',
  path: '/dances',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const UiShowcaseRoute = UiShowcaseRouteImport.update({
  id: '/ui-showcase',
  path: '/ui-showcase',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const BallroomsIndexRoute = BallroomsIndexRouteImport.update({
  id: '/ballrooms/',
  path: '/ballrooms/',
  getParentRoute: () => rootRouteImport,
} as any)
const DancesIndexRoute = DancesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DancesRouteRoute,
} as any)
const DancesDanceIdRoute = DancesDanceIdRouteImport.update({
  id: '/$danceId',
  path: '/$danceId',
  getParentRoute: () => DancesRouteRoute,
} as any)
const EventsNewRoute = EventsNewRouteImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => rootRouteImport,
} as any)
const VolunteersIndexRoute = VolunteersIndexRouteImport.update({
  id: '/volunteers/',
  path: '/volunteers/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsEventIdChar123EventVersionIdChar125RouteRoute =
  EventsEventIdChar123EventVersionIdChar125RouteRouteImport.update({
    id: '/events/$eventId/{-$eventVersionId}',
    path: '/events/$eventId/{-$eventVersionId}',
    getParentRoute: () => rootRouteImport,
  } as any)
const DancesDanceIdVersionDanceVersionIdRoute =
  DancesDanceIdVersionDanceVersionIdRouteImport.update({
    id: '/version/$danceVersionId',
    path: '/version/$danceVersionId',
    getParentRoute: () => DancesDanceIdRoute,
  } as any)
const EventsEventIdVersionEventVersionIdRoute =
  EventsEventIdVersionEventVersionIdRouteImport.update({
    id: '/events/$eventId/version/$eventVersionId',
    path: '/events/$eventId/version/$eventVersionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const EventsEventIdChar123EventVersionIdChar125IndexRoute =
  EventsEventIdChar123EventVersionIdChar125IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
  } as any)
const EventsEventIdChar123EventVersionIdChar125EditRoute =
  EventsEventIdChar123EventVersionIdChar125EditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
  } as any)
const EventsEventIdChar123EventVersionIdChar125ProgramRouteRoute =
  EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteImport.update({
    id: '/program',
    path: '/program',
    getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
  } as any)
const EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRoute =
  EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRouteImport.update({
    id: '/assignments/',
    path: '/assignments/',
    getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
  } as any)
const EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125Route =
  EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125RouteImport.update(
    {
      id: '/ball-program/{-$slideId}',
      path: '/ball-program/{-$slideId}',
      getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRoute =
  EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteImport.update(
    {
      id: '/documents/$documentId',
      path: '/documents/$documentId',
      getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRoute =
  EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRouteImport.update(
    {
      id: '/print/ball-dancelist',
      path: '/print/ball-dancelist',
      getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRoute =
  EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRouteImport.update(
    {
      id: '/print/dance-cheatlist',
      path: '/print/dance-cheatlist',
      getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRoute =
  EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRouteImport.update(
    {
      id: '/print/dance-instructions',
      path: '/print/dance-instructions',
      getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125VolunteersIndexRoute =
  EventsEventIdChar123EventVersionIdChar125VolunteersIndexRouteImport.update({
    id: '/volunteers/',
    path: '/volunteers/',
    getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
  } as any)
const EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRoute =
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteImport.update(
    {
      id: '/workshops/$workshopId',
      path: '/workshops/$workshopId',
      getParentRoute: () => EventsEventIdChar123EventVersionIdChar125RouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRoute =
  EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRoute =
  EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRouteImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRoute =
  EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRouteImport.update({
    id: '/main/',
    path: '/main/',
    getParentRoute: () =>
      EventsEventIdChar123EventVersionIdChar125ProgramRouteRoute,
  } as any)
const EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125Route =
  EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125RouteImport.update(
    {
      id: '/slides/{-$slideId}',
      path: '/slides/{-$slideId}',
      getParentRoute: () =>
        EventsEventIdChar123EventVersionIdChar125ProgramRouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRoute =
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRoute =
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteImport.update(
    {
      id: '/documents/$documentId',
      path: '/documents/$documentId',
      getParentRoute: () =>
        EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRoute =
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRoute,
    } as any,
  )
const EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRoute =
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRouteImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dances': typeof DancesRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/ui-showcase': typeof UiShowcaseRoute
  '/users': typeof UsersRoute
  '/dances/$danceId': typeof DancesDanceIdRouteWithChildren
  '/events/new': typeof EventsNewRoute
  '/ballrooms/': typeof BallroomsIndexRoute
  '/dances/': typeof DancesIndexRoute
  '/volunteers/': typeof VolunteersIndexRoute
  '/events/$eventId/{-$eventVersionId}': typeof EventsEventIdChar123EventVersionIdChar125RouteRouteWithChildren
  '/events/$eventId/{-$eventVersionId}/program': typeof EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteWithChildren
  '/dances/$danceId/version/$danceVersionId': typeof DancesDanceIdVersionDanceVersionIdRoute
  '/events/$eventId/version/$eventVersionId': typeof EventsEventIdVersionEventVersionIdRoute
  '/events/$eventId/{-$eventVersionId}/edit': typeof EventsEventIdChar123EventVersionIdChar125EditRoute
  '/events/$eventId/{-$eventVersionId}/': typeof EventsEventIdChar123EventVersionIdChar125IndexRoute
  '/events/$eventId/{-$eventVersionId}/documents/$documentId': typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteWithChildren
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteWithChildren
  '/events/$eventId/{-$eventVersionId}/ball-program/{-$slideId}': typeof EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125Route
  '/events/$eventId/{-$eventVersionId}/print/ball-dancelist': typeof EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRoute
  '/events/$eventId/{-$eventVersionId}/print/dance-cheatlist': typeof EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRoute
  '/events/$eventId/{-$eventVersionId}/print/dance-instructions': typeof EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRoute
  '/events/$eventId/{-$eventVersionId}/assignments/': typeof EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRoute
  '/events/$eventId/{-$eventVersionId}/volunteers/': typeof EventsEventIdChar123EventVersionIdChar125VolunteersIndexRoute
  '/events/$eventId/{-$eventVersionId}/documents/$documentId/edit': typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRoute
  '/events/$eventId/{-$eventVersionId}/program/slides/{-$slideId}': typeof EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125Route
  '/events/$eventId/{-$eventVersionId}/documents/$documentId/': typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRoute
  '/events/$eventId/{-$eventVersionId}/program/main/': typeof EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRoute
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRoute
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteWithChildren
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/edit': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRoute
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/ui-showcase': typeof UiShowcaseRoute
  '/users': typeof UsersRoute
  '/dances/$danceId': typeof DancesDanceIdRouteWithChildren
  '/events/new': typeof EventsNewRoute
  '/ballrooms': typeof BallroomsIndexRoute
  '/dances': typeof DancesIndexRoute
  '/volunteers': typeof VolunteersIndexRoute
  '/events/$eventId/{-$eventVersionId}/program': typeof EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteWithChildren
  '/dances/$danceId/version/$danceVersionId': typeof DancesDanceIdVersionDanceVersionIdRoute
  '/events/$eventId/version/$eventVersionId': typeof EventsEventIdVersionEventVersionIdRoute
  '/events/$eventId/{-$eventVersionId}/edit': typeof EventsEventIdChar123EventVersionIdChar125EditRoute
  '/events/$eventId/{-$eventVersionId}': typeof EventsEventIdChar123EventVersionIdChar125IndexRoute
  '/events/$eventId/{-$eventVersionId}/ball-program/{-$slideId}': typeof EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125Route
  '/events/$eventId/{-$eventVersionId}/print/ball-dancelist': typeof EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRoute
  '/events/$eventId/{-$eventVersionId}/print/dance-cheatlist': typeof EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRoute
  '/events/$eventId/{-$eventVersionId}/print/dance-instructions': typeof EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRoute
  '/events/$eventId/{-$eventVersionId}/assignments': typeof EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRoute
  '/events/$eventId/{-$eventVersionId}/volunteers': typeof EventsEventIdChar123EventVersionIdChar125VolunteersIndexRoute
  '/events/$eventId/{-$eventVersionId}/documents/$documentId/edit': typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRoute
  '/events/$eventId/{-$eventVersionId}/program/slides/{-$slideId}': typeof EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125Route
  '/events/$eventId/{-$eventVersionId}/documents/$documentId': typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRoute
  '/events/$eventId/{-$eventVersionId}/program/main': typeof EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRoute
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRoute
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/edit': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRoute
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dances': typeof DancesRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/ui-showcase': typeof UiShowcaseRoute
  '/users': typeof UsersRoute
  '/dances/$danceId': typeof DancesDanceIdRouteWithChildren
  '/events/new': typeof EventsNewRoute
  '/ballrooms/': typeof BallroomsIndexRoute
  '/dances/': typeof DancesIndexRoute
  '/volunteers/': typeof VolunteersIndexRoute
  '/events/$eventId/{-$eventVersionId}': typeof EventsEventIdChar123EventVersionIdChar125RouteRouteWithChildren
  '/events/$eventId/{-$eventVersionId}/program': typeof EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteWithChildren
  '/dances/$danceId/version/$danceVersionId': typeof DancesDanceIdVersionDanceVersionIdRoute
  '/events/$eventId/version/$eventVersionId': typeof EventsEventIdVersionEventVersionIdRoute
  '/events/$eventId/{-$eventVersionId}/edit': typeof EventsEventIdChar123EventVersionIdChar125EditRoute
  '/events/$eventId/{-$eventVersionId}/': typeof EventsEventIdChar123EventVersionIdChar125IndexRoute
  '/events/$eventId/{-$eventVersionId}/documents/$documentId': typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteWithChildren
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteWithChildren
  '/events/$eventId/{-$eventVersionId}/ball-program/{-$slideId}': typeof EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125Route
  '/events/$eventId/{-$eventVersionId}/print/ball-dancelist': typeof EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRoute
  '/events/$eventId/{-$eventVersionId}/print/dance-cheatlist': typeof EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRoute
  '/events/$eventId/{-$eventVersionId}/print/dance-instructions': typeof EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRoute
  '/events/$eventId/{-$eventVersionId}/assignments/': typeof EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRoute
  '/events/$eventId/{-$eventVersionId}/volunteers/': typeof EventsEventIdChar123EventVersionIdChar125VolunteersIndexRoute
  '/events/$eventId/{-$eventVersionId}/documents/$documentId/edit': typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRoute
  '/events/$eventId/{-$eventVersionId}/program/slides/{-$slideId}': typeof EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125Route
  '/events/$eventId/{-$eventVersionId}/documents/$documentId/': typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRoute
  '/events/$eventId/{-$eventVersionId}/program/main/': typeof EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRoute
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRoute
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteWithChildren
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/edit': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRoute
  '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/': typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dances'
    | '/login'
    | '/privacy-policy'
    | '/ui-showcase'
    | '/users'
    | '/dances/$danceId'
    | '/events/new'
    | '/ballrooms/'
    | '/dances/'
    | '/volunteers/'
    | '/events/$eventId/{-$eventVersionId}'
    | '/events/$eventId/{-$eventVersionId}/program'
    | '/dances/$danceId/version/$danceVersionId'
    | '/events/$eventId/version/$eventVersionId'
    | '/events/$eventId/{-$eventVersionId}/edit'
    | '/events/$eventId/{-$eventVersionId}/'
    | '/events/$eventId/{-$eventVersionId}/documents/$documentId'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId'
    | '/events/$eventId/{-$eventVersionId}/ball-program/{-$slideId}'
    | '/events/$eventId/{-$eventVersionId}/print/ball-dancelist'
    | '/events/$eventId/{-$eventVersionId}/print/dance-cheatlist'
    | '/events/$eventId/{-$eventVersionId}/print/dance-instructions'
    | '/events/$eventId/{-$eventVersionId}/assignments/'
    | '/events/$eventId/{-$eventVersionId}/volunteers/'
    | '/events/$eventId/{-$eventVersionId}/documents/$documentId/edit'
    | '/events/$eventId/{-$eventVersionId}/program/slides/{-$slideId}'
    | '/events/$eventId/{-$eventVersionId}/documents/$documentId/'
    | '/events/$eventId/{-$eventVersionId}/program/main/'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/edit'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/privacy-policy'
    | '/ui-showcase'
    | '/users'
    | '/dances/$danceId'
    | '/events/new'
    | '/ballrooms'
    | '/dances'
    | '/volunteers'
    | '/events/$eventId/{-$eventVersionId}/program'
    | '/dances/$danceId/version/$danceVersionId'
    | '/events/$eventId/version/$eventVersionId'
    | '/events/$eventId/{-$eventVersionId}/edit'
    | '/events/$eventId/{-$eventVersionId}'
    | '/events/$eventId/{-$eventVersionId}/ball-program/{-$slideId}'
    | '/events/$eventId/{-$eventVersionId}/print/ball-dancelist'
    | '/events/$eventId/{-$eventVersionId}/print/dance-cheatlist'
    | '/events/$eventId/{-$eventVersionId}/print/dance-instructions'
    | '/events/$eventId/{-$eventVersionId}/assignments'
    | '/events/$eventId/{-$eventVersionId}/volunteers'
    | '/events/$eventId/{-$eventVersionId}/documents/$documentId/edit'
    | '/events/$eventId/{-$eventVersionId}/program/slides/{-$slideId}'
    | '/events/$eventId/{-$eventVersionId}/documents/$documentId'
    | '/events/$eventId/{-$eventVersionId}/program/main'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/edit'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId'
  id:
    | '__root__'
    | '/'
    | '/dances'
    | '/login'
    | '/privacy-policy'
    | '/ui-showcase'
    | '/users'
    | '/dances/$danceId'
    | '/events/new'
    | '/ballrooms/'
    | '/dances/'
    | '/volunteers/'
    | '/events/$eventId/{-$eventVersionId}'
    | '/events/$eventId/{-$eventVersionId}/program'
    | '/dances/$danceId/version/$danceVersionId'
    | '/events/$eventId/version/$eventVersionId'
    | '/events/$eventId/{-$eventVersionId}/edit'
    | '/events/$eventId/{-$eventVersionId}/'
    | '/events/$eventId/{-$eventVersionId}/documents/$documentId'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId'
    | '/events/$eventId/{-$eventVersionId}/ball-program/{-$slideId}'
    | '/events/$eventId/{-$eventVersionId}/print/ball-dancelist'
    | '/events/$eventId/{-$eventVersionId}/print/dance-cheatlist'
    | '/events/$eventId/{-$eventVersionId}/print/dance-instructions'
    | '/events/$eventId/{-$eventVersionId}/assignments/'
    | '/events/$eventId/{-$eventVersionId}/volunteers/'
    | '/events/$eventId/{-$eventVersionId}/documents/$documentId/edit'
    | '/events/$eventId/{-$eventVersionId}/program/slides/{-$slideId}'
    | '/events/$eventId/{-$eventVersionId}/documents/$documentId/'
    | '/events/$eventId/{-$eventVersionId}/program/main/'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/edit'
    | '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DancesRouteRoute: typeof DancesRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  UiShowcaseRoute: typeof UiShowcaseRoute
  UsersRoute: typeof UsersRoute
  EventsNewRoute: typeof EventsNewRoute
  BallroomsIndexRoute: typeof BallroomsIndexRoute
  VolunteersIndexRoute: typeof VolunteersIndexRoute
  EventsEventIdChar123EventVersionIdChar125RouteRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRouteWithChildren
  EventsEventIdVersionEventVersionIdRoute: typeof EventsEventIdVersionEventVersionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dances': {
      id: '/dances'
      path: '/dances'
      fullPath: '/dances'
      preLoaderRoute: typeof DancesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui-showcase': {
      id: '/ui-showcase'
      path: '/ui-showcase'
      fullPath: '/ui-showcase'
      preLoaderRoute: typeof UiShowcaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ballrooms/': {
      id: '/ballrooms/'
      path: '/ballrooms'
      fullPath: '/ballrooms/'
      preLoaderRoute: typeof BallroomsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dances/': {
      id: '/dances/'
      path: '/'
      fullPath: '/dances/'
      preLoaderRoute: typeof DancesIndexRouteImport
      parentRoute: typeof DancesRouteRoute
    }
    '/dances/$danceId': {
      id: '/dances/$danceId'
      path: '/$danceId'
      fullPath: '/dances/$danceId'
      preLoaderRoute: typeof DancesDanceIdRouteImport
      parentRoute: typeof DancesRouteRoute
    }
    '/events/new': {
      id: '/events/new'
      path: '/events/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof EventsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/volunteers/': {
      id: '/volunteers/'
      path: '/volunteers'
      fullPath: '/volunteers/'
      preLoaderRoute: typeof VolunteersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$eventId/{-$eventVersionId}': {
      id: '/events/$eventId/{-$eventVersionId}'
      path: '/events/$eventId/{-$eventVersionId}'
      fullPath: '/events/$eventId/{-$eventVersionId}'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dances/$danceId/version/$danceVersionId': {
      id: '/dances/$danceId/version/$danceVersionId'
      path: '/version/$danceVersionId'
      fullPath: '/dances/$danceId/version/$danceVersionId'
      preLoaderRoute: typeof DancesDanceIdVersionDanceVersionIdRouteImport
      parentRoute: typeof DancesDanceIdRoute
    }
    '/events/$eventId/version/$eventVersionId': {
      id: '/events/$eventId/version/$eventVersionId'
      path: '/events/$eventId/version/$eventVersionId'
      fullPath: '/events/$eventId/version/$eventVersionId'
      preLoaderRoute: typeof EventsEventIdVersionEventVersionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$eventId/{-$eventVersionId}/': {
      id: '/events/$eventId/{-$eventVersionId}/'
      path: '/'
      fullPath: '/events/$eventId/{-$eventVersionId}/'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125IndexRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/edit': {
      id: '/events/$eventId/{-$eventVersionId}/edit'
      path: '/edit'
      fullPath: '/events/$eventId/{-$eventVersionId}/edit'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125EditRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/program': {
      id: '/events/$eventId/{-$eventVersionId}/program'
      path: '/program'
      fullPath: '/events/$eventId/{-$eventVersionId}/program'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/assignments/': {
      id: '/events/$eventId/{-$eventVersionId}/assignments/'
      path: '/assignments'
      fullPath: '/events/$eventId/{-$eventVersionId}/assignments/'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/ball-program/{-$slideId}': {
      id: '/events/$eventId/{-$eventVersionId}/ball-program/{-$slideId}'
      path: '/ball-program/{-$slideId}'
      fullPath: '/events/$eventId/{-$eventVersionId}/ball-program/{-$slideId}'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125RouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/documents/$documentId': {
      id: '/events/$eventId/{-$eventVersionId}/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/events/$eventId/{-$eventVersionId}/documents/$documentId'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/print/ball-dancelist': {
      id: '/events/$eventId/{-$eventVersionId}/print/ball-dancelist'
      path: '/print/ball-dancelist'
      fullPath: '/events/$eventId/{-$eventVersionId}/print/ball-dancelist'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/print/dance-cheatlist': {
      id: '/events/$eventId/{-$eventVersionId}/print/dance-cheatlist'
      path: '/print/dance-cheatlist'
      fullPath: '/events/$eventId/{-$eventVersionId}/print/dance-cheatlist'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/print/dance-instructions': {
      id: '/events/$eventId/{-$eventVersionId}/print/dance-instructions'
      path: '/print/dance-instructions'
      fullPath: '/events/$eventId/{-$eventVersionId}/print/dance-instructions'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/volunteers/': {
      id: '/events/$eventId/{-$eventVersionId}/volunteers/'
      path: '/volunteers'
      fullPath: '/events/$eventId/{-$eventVersionId}/volunteers/'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125VolunteersIndexRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/workshops/$workshopId': {
      id: '/events/$eventId/{-$eventVersionId}/workshops/$workshopId'
      path: '/workshops/$workshopId'
      fullPath: '/events/$eventId/{-$eventVersionId}/workshops/$workshopId'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125RouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/documents/$documentId/': {
      id: '/events/$eventId/{-$eventVersionId}/documents/$documentId/'
      path: '/'
      fullPath: '/events/$eventId/{-$eventVersionId}/documents/$documentId/'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/documents/$documentId/edit': {
      id: '/events/$eventId/{-$eventVersionId}/documents/$documentId/edit'
      path: '/edit'
      fullPath: '/events/$eventId/{-$eventVersionId}/documents/$documentId/edit'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/program/main/': {
      id: '/events/$eventId/{-$eventVersionId}/program/main/'
      path: '/main'
      fullPath: '/events/$eventId/{-$eventVersionId}/program/main/'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125ProgramRouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/program/slides/{-$slideId}': {
      id: '/events/$eventId/{-$eventVersionId}/program/slides/{-$slideId}'
      path: '/slides/{-$slideId}'
      fullPath: '/events/$eventId/{-$eventVersionId}/program/slides/{-$slideId}'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125RouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125ProgramRouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/': {
      id: '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/'
      path: '/'
      fullPath: '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId': {
      id: '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/': {
      id: '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/'
      path: '/'
      fullPath: '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRoute
    }
    '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/edit': {
      id: '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/edit'
      path: '/edit'
      fullPath: '/events/$eventId/{-$eventVersionId}/workshops/$workshopId/documents/$documentId/edit'
      preLoaderRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRouteImport
      parentRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRoute
    }
  }
}

interface DancesDanceIdRouteChildren {
  DancesDanceIdVersionDanceVersionIdRoute: typeof DancesDanceIdVersionDanceVersionIdRoute
}

const DancesDanceIdRouteChildren: DancesDanceIdRouteChildren = {
  DancesDanceIdVersionDanceVersionIdRoute:
    DancesDanceIdVersionDanceVersionIdRoute,
}

const DancesDanceIdRouteWithChildren = DancesDanceIdRoute._addFileChildren(
  DancesDanceIdRouteChildren,
)

interface DancesRouteRouteChildren {
  DancesDanceIdRoute: typeof DancesDanceIdRouteWithChildren
  DancesIndexRoute: typeof DancesIndexRoute
}

const DancesRouteRouteChildren: DancesRouteRouteChildren = {
  DancesDanceIdRoute: DancesDanceIdRouteWithChildren,
  DancesIndexRoute: DancesIndexRoute,
}

const DancesRouteRouteWithChildren = DancesRouteRoute._addFileChildren(
  DancesRouteRouteChildren,
)

interface EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteChildren {
  EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125Route: typeof EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125Route
  EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRoute: typeof EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRoute
}

const EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteChildren: EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteChildren =
  {
    EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125Route:
      EventsEventIdChar123EventVersionIdChar125ProgramSlidesChar123SlideIdChar125Route,
    EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRoute:
      EventsEventIdChar123EventVersionIdChar125ProgramMainIndexRoute,
  }

const EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteWithChildren =
  EventsEventIdChar123EventVersionIdChar125ProgramRouteRoute._addFileChildren(
    EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteChildren,
  )

interface EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteChildren {
  EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRoute: typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRoute
  EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRoute: typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRoute
}

const EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteChildren: EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteChildren =
  {
    EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRoute:
      EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdEditRoute,
    EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRoute:
      EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdIndexRoute,
  }

const EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteWithChildren =
  EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRoute._addFileChildren(
    EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteChildren,
  )

interface EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteChildren {
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRoute
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRoute
}

const EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteChildren: EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteChildren =
  {
    EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRoute:
      EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdEditRoute,
    EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRoute:
      EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdIndexRoute,
  }

const EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteWithChildren =
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRoute._addFileChildren(
    EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteChildren,
  )

interface EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteChildren {
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRoute
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteWithChildren
}

const EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteChildren: EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteChildren =
  {
    EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRoute:
      EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdIndexRoute,
    EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRoute:
      EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdDocumentsDocumentIdRouteRouteWithChildren,
  }

const EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteWithChildren =
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRoute._addFileChildren(
    EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteChildren,
  )

interface EventsEventIdChar123EventVersionIdChar125RouteRouteChildren {
  EventsEventIdChar123EventVersionIdChar125ProgramRouteRoute: typeof EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteWithChildren
  EventsEventIdChar123EventVersionIdChar125EditRoute: typeof EventsEventIdChar123EventVersionIdChar125EditRoute
  EventsEventIdChar123EventVersionIdChar125IndexRoute: typeof EventsEventIdChar123EventVersionIdChar125IndexRoute
  EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRoute: typeof EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteWithChildren
  EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRoute: typeof EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteWithChildren
  EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125Route: typeof EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125Route
  EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRoute: typeof EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRoute
  EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRoute: typeof EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRoute
  EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRoute: typeof EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRoute
  EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRoute: typeof EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRoute
  EventsEventIdChar123EventVersionIdChar125VolunteersIndexRoute: typeof EventsEventIdChar123EventVersionIdChar125VolunteersIndexRoute
}

const EventsEventIdChar123EventVersionIdChar125RouteRouteChildren: EventsEventIdChar123EventVersionIdChar125RouteRouteChildren =
  {
    EventsEventIdChar123EventVersionIdChar125ProgramRouteRoute:
      EventsEventIdChar123EventVersionIdChar125ProgramRouteRouteWithChildren,
    EventsEventIdChar123EventVersionIdChar125EditRoute:
      EventsEventIdChar123EventVersionIdChar125EditRoute,
    EventsEventIdChar123EventVersionIdChar125IndexRoute:
      EventsEventIdChar123EventVersionIdChar125IndexRoute,
    EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRoute:
      EventsEventIdChar123EventVersionIdChar125DocumentsDocumentIdRouteRouteWithChildren,
    EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRoute:
      EventsEventIdChar123EventVersionIdChar125WorkshopsWorkshopIdRouteRouteWithChildren,
    EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125Route:
      EventsEventIdChar123EventVersionIdChar125BallProgramChar123SlideIdChar125Route,
    EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRoute:
      EventsEventIdChar123EventVersionIdChar125PrintBallDancelistRoute,
    EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRoute:
      EventsEventIdChar123EventVersionIdChar125PrintDanceCheatlistRoute,
    EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRoute:
      EventsEventIdChar123EventVersionIdChar125PrintDanceInstructionsRoute,
    EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRoute:
      EventsEventIdChar123EventVersionIdChar125AssignmentsIndexRoute,
    EventsEventIdChar123EventVersionIdChar125VolunteersIndexRoute:
      EventsEventIdChar123EventVersionIdChar125VolunteersIndexRoute,
  }

const EventsEventIdChar123EventVersionIdChar125RouteRouteWithChildren =
  EventsEventIdChar123EventVersionIdChar125RouteRoute._addFileChildren(
    EventsEventIdChar123EventVersionIdChar125RouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DancesRouteRoute: DancesRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  UiShowcaseRoute: UiShowcaseRoute,
  UsersRoute: UsersRoute,
  EventsNewRoute: EventsNewRoute,
  BallroomsIndexRoute: BallroomsIndexRoute,
  VolunteersIndexRoute: VolunteersIndexRoute,
  EventsEventIdChar123EventVersionIdChar125RouteRoute:
    EventsEventIdChar123EventVersionIdChar125RouteRouteWithChildren,
  EventsEventIdVersionEventVersionIdRoute:
    EventsEventIdVersionEventVersionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
